import styled from '@emotion/styled';

const PausedMessage = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    line-height: 1.8;
    background: transparent;
    padding: 24px 32px;
    border-radius: 12px;
    width: 700px;
    text-align: left;

    h1 {
        font-size: 20px;
        margin-bottom: 16px;
        text-align: center;
    }

    .step {
        display: flex;
        align-items: center;
        margin-bottom: 16px;

        .number {
            color: white;
            font-size: 16px;
            font-weight: bold;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 12px;
            border: 2px solid white;
            background-color: transparent;
        }

        .text {
            flex: 1;
        }

        .icon {
            margin-left: 12px;
            img {
                width: 32px;
                height: 32px;
                border-radius: 50%;
                object-fit: cover;
            }
        }
    }
`;

export const IdleGuide = () => {
    return (
        <PausedMessage>
            <h1>Record a silent Avatar state:</h1>
            <div className="step">
                <div className="number">1</div>
                <div className="text">Look directly at the camera with a natural smile and breathe.</div>
            </div>
            <div className="step">
                <div className="number">2</div>
                <div className="text">Avoid hand gestures.</div>
            </div>
        </PausedMessage>
    );
};
